<template>
  <div class="bottom-wrap nx-flex-center-center">
    <van-button class="btn" @click="openAPP">打开北京汽车APP</van-button>
    <nx-guide
      :visible.sync="show"
    />
  </div>
</template>

<script>
import { Toast } from 'vant';
import {
  isJudgeDevice,
  isWeChatBrowser,
} from '@/utils/is';
export default {
  name: 'NxBottomDownload',
  props: {
    zoneHomeCode: {
      type: String,
      default: () => '', // 专区code
    },
    jumpType: {
      type: [String, Number],
      default: () => '', // 跳转类型（参考在线文档，统一type） https://beijing-app.feishu.cn/sheets/shtcn5I2PlKhHfZZPG60tLDDHoe
    },
    contentId: {
      type: [String, Number],
      default: () => '', // 详情id
    },
    contentType: {
      type: [String, Number],
      default: () => '', // 详情小类型（例如资讯：1-文章 2-视频，活动：1-线下官方 2-资讯活动）
    },
  },
  data() {
    return {
      show: false,
    };
  },
  created() {
  },
  methods: {
    openAPP() {
      // 判断用户是否在微信打开
      if (isWeChatBrowser()) {
        this.show = true;
        return;
      }

      // 判断当前环境是否在安卓或ios
      if (!isJudgeDevice() === 'IOS' && !isJudgeDevice() === 'Android') {
        return Toast({
          message: '暂不支持该机型',
          forbidClick: true,
        });
      }

      if (isJudgeDevice() === 'IOS') {
        window.location = `bjev-zhgj://?zone_home_code=${this.zoneHomeCode}&jumpType=${this.jumpType}&contentId=${this.contentId}&contentType=${this.contentType}`;
      }

      if (isJudgeDevice() === 'Android') {
        window.location = `bjev-zhgj://com_dj_xny?zone_home_code=${this.zoneHomeCode}&jumpType=${this.jumpType}&contentId=${this.contentId}&contentType=${this.contentType}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.bottom-wrap{
  position: fixed;
  bottom:0;
  left:0;
  width: 100%;
  height: 46px;
  z-index: 9;
 .btn{
    width: 100%;
    height: 100%;
    text-align: center;
    background: rgba(0, 0, 0, .6);
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 20px;
    border-width: 0 !important;
    border-radius: 0;
  }

}

</style>
